import React, { Component, useEffect, useRef, useState } from "react";
import {
  Layout,
  Menu,
  Button,
  Typography,
  Card,
  Form,
  Input,
  Checkbox,
  message, Steps,
  notification
} from "antd";
import logo1 from "../assets/images/logos-facebook.svg";
import logo2 from "../assets/images/logo-apple.svg";
import logo3 from "../assets/images/Google__G__Logo.svg.png";

import { Link, useHistory } from "react-router-dom";
import {
  DribbbleOutlined,
  TwitterOutlined,
  InstagramOutlined,
  GithubOutlined,
  CarFilled,
} from "@ant-design/icons";

import AirplaneIcon from '../assets/images/airplane.png';
import CarIcon from '../assets/images/car.png';
import TourismIcon from '../assets/images/tourism.png';
import JourneyForm from "../components/forms/JourneyForm";
import { LoadScript } from "@react-google-maps/api";
import VehiclePlans from "../components/forms/VehiclesForm";
import Summary from "../components/forms/Summary";
import MapWithRoute from "../components/maps/MapWithRoute";

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from "../components/forms/CheckoutForm";
import { getVehicles, getVehiclesTypes } from "../api/vehicles-type.service";
import axiosClient from "../api/axiosClient";
import { createBookingRental } from "../api/booking.service";
import VehicleRentalSelectForm from "../components/forms/VehicleRentalSelectForm";
import CheckoutFormRental from "../components/forms/CheckoutFormRental";
import DatesRentalSelectForm from "../components/forms/DatesRentalSelectForm";
import RentalSummary from "../components/forms/RentalSummary";
import UserInfoRentalForm from "../components/forms/UserInfoRentalForm";
import dayjs from "dayjs";
import CurrencySelector from "../context/CurrencySelector";
import { useCurrency } from "../context/CurrencyContext";
import { useCurrencyConverter } from "../context/currencyHook";

import SawariLogo from '../assets/sawari-logo.png';
import HeaderBar from "./HeaderBar";
import Footerbar from "../sections/Footerbar";
import config from '../config';

const stripePromise = loadStripe(config.STRIPE_PUBLIC_KEY);

const { Title } = Typography;
const { Header, Footer, Content } = Layout;

export default function VehicleRentals() {

  const history = useHistory()

  const formRef = useRef();
  const [current, setCurrent] = useState(0);

  const [formData, setFormData] = useState({
    dateRange: [dayjs(), dayjs()],
  }); // To store form data


  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [selectedVehicleReturn, setSelectedVehicleReturn] = useState(null);

  const [summaryObj, setSummaryObj] = useState(null);

  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [errorBooking, setErrorBooking] = useState(false);

  const [successMessage, setSuccessMessage] = useState('');
  const [amount, setAmount] = useState(0);
  const [discountedAmount, setDiscountedAmount] = useState(null);

  const convertCurrency = useCurrencyConverter();
  const { currency } = useCurrency();

  const handleSuccess = (discountCode) => {
    let data = {
      amount,
      ...formData,
    }
    localStorage.setItem("confirmedPaymentCautionBookingRentalBody", JSON.stringify(data));
    handleBookingRental(data, discountCode);
  }

  const handleBookingRental = async (body, discountCode) => {
    setLoading(true);
    setErrorBooking(false);
    setSuccessMessage('');

    const bookingData = body

    try {
      // Convert amounts to selected currency and include in summaryObj
      const convertedAmount = convertCurrency(amount);
      const finalDiscountedAmount = discountedAmount !== null && discountedAmount !== undefined 
        ? convertCurrency(discountedAmount) 
        : convertedAmount;
      
      const finalSummaryObj = {
        ...summaryObj,
        amount: convertedAmount,
        discountedAmount: finalDiscountedAmount,
        currency,
        discountCode: discountCode || '-'
      };
      
      console.log('[AF][VR] summaryObj with amounts:', finalSummaryObj);
      
      const response = await createBookingRental({...bookingData, summaryObj: finalSummaryObj});
      notification.success({ message: 'Booking created successfully!' });
      localStorage.removeItem("confirmedPaymentCautionBookingRentalBody");
      console.log('Booking response:', response);
      setErrorBooking(false)
      localStorage.setItem("summaryObjRental", JSON.stringify({...finalSummaryObj, ...bookingData}));
      setTimeout(() => {
        history.push('/confirmation-rental');
      }, 500);

    } catch (err) {
      setErrorBooking(true)
      notification.error({ message: 'Failed to create booking.' });
    } finally {
      setLoading(false);
    }
  };

  const fetchVehicles = async () => {
    try {
      setLoading(true);
      const data = await getVehiclesTypes();
      setVehicles(data?.data || []); // Set the fetched vehicles data
    } catch (err) {
      notification.error({ message: 'Failed to fetch vehicles' });
      setError('Failed to fetch vehicles');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (current == 1) {
      if (vehicles?.length == 0) {
        fetchVehicles();
      }
    }
  }, [current])


  useEffect(() => {
    setFormData({
      ...formData,
      selectedVehicle: selectedVehicle,
    })
  }, [selectedVehicle])


  useEffect(() => {
    let obj = {
      perDayRent: formData?.selectedVehicle?.perDayPricePKR || 1,
      dateRange: formData?.dateRange,
      selectedVehicle: formData?.selectedVehicle,
      pickupLocation: formData?.pickupLocation,
      dropoffLocation: formData?.dropoffLocation
    }
    setSummaryObj(obj)
  }, [formData]);

  const next = async () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    if (current == 0) {
      if (formRef.current) {
        if (formRef.current) {
          const { valid, values, errors } = await formRef.current.validate();
          if (valid) {
            setFormData({ ...formData, ...values }); // Save form data
            setCurrent(current + 1);
          } else {
            message.error("Form validation failed!");
            console.log("Validation Errors:", errors);
          }
        }
      }
    }
    else if (current == 1) {
      if (formRef.current) {
        if (!selectedVehicle) {
          message.error("Please select a vehicle!");
          return;
        }
        const { valid, values, errors } = await formRef.current.validate();
        if (valid) {
          setFormData({ ...formData, ...values }); // Save form data
          setCurrent(current + 1);
        } else {
          message.error("Form validation failed!");
          console.log("Validation Errors:", errors);
        }
      }
    }
    else {
      setCurrent(current + 1);
    }
  };

  const prev = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    setCurrent(current - 1);
  };


  const retryBooking = () => {
    let data = localStorage.getItem("confirmedPaymentCautionBookingRentalBody");
    let body = JSON.parse(data);
    handleBookingRental(body);
  }

  const steps = [
    {
      title: <span style={{color: 'black', fontWeight: 'bold'}}>User</span>,
      content: (
        <div>
          <UserInfoRentalForm ref={formRef} initialValues={formData} />
        </div>
      ),
    },
    {
      title: <span style={{color: 'black', fontWeight: 'bold'}}>Vehicle and Dates</span>,
      content: (
        <div>
          <VehicleRentalSelectForm ref={formRef} initialValues={formData} loading={loading} vehicles={vehicles} setSelectedVehicleReturn={setSelectedVehicleReturn} selectedVehicleReturn={selectedVehicleReturn} setSelectedVehicle={setSelectedVehicle} selectedVehicle={selectedVehicle} />
        </div>
      ),
    },
    {
      title: <span style={{color: 'black', fontWeight: 'bold'}}>Summary</span>,
      content: (
        <div>
          <RentalSummary setAmount={setAmount} perDayRent={formData?.selectedVehicle?.perDayPricePKR || 1} dateRange={formData?.dateRange} selectedVehicle={formData?.selectedVehicle}/>
        </div>
      ),
    },
    {
      title: <span style={{color: 'black', fontWeight: 'bold'}}>Payment</span>,
      content: (
        <div>
          <Elements stripe={stripePromise}>
            <CheckoutForm discountedAmount={discountedAmount} setDiscountedAmount={setDiscountedAmount} amount={amount} retryBooking={retryBooking} errorBooking={errorBooking} handleSuccess={handleSuccess} />
          </Elements>
        </div>
      ),
    },
  ];

  const items = steps.map((item) => ({ key: item.title, title: item.title }));

  const contentStyle = {
    textAlign: 'center',
    color: "#00803e",
    backgroundColor: "white",
    borderRadius: "8px",
    border: 'none',
    marginTop: 16,
    padding: '1rem',
    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px'
  };

  return (
    <>
      <div className="layout-default ant-layout layout-sign-up">
        <HeaderBar />

        <div className="landing-header absolute w-full z-0" style={{
          position: 'absolute',
          width: '100%',
          zIndex: 0
        }}>
          <div className="content">
            <Title style={{color: 'black'}}>Vehicle Rentals</Title>
          </div>
        </div>

        <div className="p-8 my-16 lg:mx-24 mx-auto" style={{
          zIndex: 20,
          marginTop: '11rem'
        }}>
          <Steps current={current} items={items} style={{backgroundColor: '#ffffff', border: '3px solid #00803e', padding: '1rem', borderRadius: '1rem'}}/>
          <div style={contentStyle}>{steps[current].content}</div>
          <div style={{ marginTop: 24 }} className="flex justify-end">
            {current > 0 && (
              <Button style={{ margin: '0 8px', borderColor: '#00803e' }} onClick={() => prev()}>
                Previous
              </Button>
            )}
            {current < steps.length - 1 && (
              <Button type="primary" style={{ backgroundColor: '#00803e', borderColor: '#00803e' }} onClick={() => next()}>
                Next
              </Button>
            )}
            {false && current === steps.length - 1 && (
              <Button type="primary" style={{ backgroundColor: '#00803e', borderColor: '#00803e' }} onClick={() => message.success('Processing complete!')}>
                Done
              </Button>
            )}
          </div>
        </div>
        <Footerbar bgColorClass="bg-neutral-light" />
      </div>
    </>
  );
}